/**
 * en-GB messages added by Phase 3 task S24 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s24EnGB = {
    'contactless.thank_you': 'Thank you. You are signed in.',
    'contactless.thank_you_out': 'Thank you. You are signed out.',
    'contactless.poster.title': 'Scan to sign in',
    'contactless.poster.hint': 'Point your phone camera at the code. No app needed.',
    'signInPoints.poster.title': 'Scan with the CloudSign app or your camera',
    'signInPoints.poster.in': 'Sign in',
    'signInPoints.poster.out': 'Sign out',
    'signInPoints.poster.both': 'Sign in or out',
    'error.contactless_off': 'Contactless sign-in is not switched on here. Please use the CloudSign app or see reception.',
    'error.contactless_too_far': 'Please sign in once you are at the site.',
    'error.contactless_already_signed_in': 'This session has already signed in.',
    'error.contactless_not_signed_in': 'There is no visit to sign out.',
    'error.contactless_rotating': 'This site uses a rotating code on the kiosk, so there is no printed poster.',
    'error.contactless_mode': 'This sign-in point does not do that.',
    'error.sign_in_point_not_found': 'Sign-in point not found.',
    'error.sign_in_point_remote': 'A remote site cannot have sign-in points.',
    'error.sign_in_point_group': 'Your group cannot use this sign-in point.',
    'error.upload_limit': 'Too many files. Please try again later.',
    'settings.contactless.rememberDays': 'Days a phone is remembered (0 = never)',
    'settings.contactless.sessionMinutes': 'Minutes a contactless session lasts',
    'settings.contactless.enabled': 'Allow contactless sign-in at this site',
    'settings.contactless.qrMode': 'QR code type (static printed code or rotating code on the kiosk)',
    'settings.contactless.maxSessionsPerHour': 'Most contactless sessions per hour (0 = no limit)',
    'settings.contactless.requireNearSite': 'Ask for the phone location and refuse if it is far from the site',
    'settings.contactless.hostSearch': 'Let visitors search for their host by name on their phone',
    'settings.contactless.hostSearchFullNames': "Show hosts' full names in that search (off = first name and surname initial)",
    'settings.contactless.showOnContactless': 'Show this group on contactless pages',
    'settings.signInPoints.posterShowsLogo': 'Show the logo on printed posters',
    'settings.signInPoints.enabled': 'Allow sign-in points at this site',
};
//# sourceMappingURL=s24.js.map